import { Directive, ElementRef, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { Subject, debounceTime, fromEvent, takeWhile, tap } from 'rxjs';

@Directive({ selector: 'ngx-datatable', standalone: true })
export class DataTableHeightDirective implements OnInit, OnDestroy {
    ALIVE: boolean;
    #el = inject(ElementRef);
    #renderer = inject(Renderer2);

    #observer: MutationObserver;
    onChange$ = new Subject<Node>();

    ngOnInit() {
        this.ALIVE = true;
        this.#initMutationObserver(this.#el);
        this.#initListeners();
    }

    ngOnDestroy(): void {
        this.#observer.disconnect();
        this.ALIVE = false;
    }

    #initListeners() {
        this.onChange$
            .pipe(
                takeWhile(() => this.ALIVE),
                debounceTime(50),
                tap(this.#resize.bind(this)),
            )
            .subscribe();

        fromEvent(window, 'resize')
            .pipe(
                takeWhile(() => this.ALIVE),
                debounceTime(50),
                tap(() => {
                    this.#resize(this.#el.nativeElement);
                }),
            )
            .subscribe();
    }

    #initMutationObserver(el: ElementRef) {
        this.#observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                this.onChange$.next(mutation.target);
            });
        });

        this.#observer.observe(el.nativeElement, { attributes: true });
    }

    #resize(el: HTMLElement) {
        const top = el.offsetTop;
        const extraHeightStuff = 94;

        const height = top + extraHeightStuff;
        this.#renderer.setStyle(this.#el.nativeElement.parentElement, '--table-scroll-height', `${height}px`, 2);
    }
}
